import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "./LoaderSlice";
import { getMOMListData, downloadPdf, uploadPdf } from "../../services";
import { showMessage } from "../../helpers";

// Create async thunks for API calls
export const getMOMList = createAsyncThunk(
  "momList/getMOMList",
  async (data, { dispatch }) => {
    dispatch(showLoader());
    try {
      const response = await getMOMListData(data);
      dispatch(hideLoader());
      return response || [];
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
      throw error;
    }
  },
);

export const downloadMOMPDF = createAsyncThunk(
  "momList/downloadMOMPDF",
  async ({ filename, data }, { dispatch }) => {
    dispatch(showLoader());
    try {
      const response = await downloadPdf(data);
      dispatch(hideLoader());
      if (response.url) window.open(response.url);
      return response;
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
      throw error;
    }
  },
);

export const uploadMOMPDF = createAsyncThunk(
  "momList/uploadMOMPDF",
  async (data, { dispatch }) => {
    dispatch(showLoader());
    try {
      const response = await uploadPdf(data);
      dispatch(hideLoader());
      if (response.document) {
        showMessage("success", "MOM uploaded successfully");
      }
      return response;
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
      throw error;
    }
  },
);

const initialState = {
  MOMList: [],
  isLoaded: false,
};

const momSlice = createSlice({
  name: "momList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get MOM List
      .addCase(getMOMList.pending, (state) => {
        state.isLoaded = false;
      })
      .addCase(getMOMList.fulfilled, (state, action) => {
        state.isLoaded = true;
        // FIXED: Store the full response to access count and results.rows
        state.MOMList = action.payload || {};
      })
      .addCase(getMOMList.rejected, (state) => {
        state.isLoaded = true;
      })

      // Download MOM PDF
      .addCase(downloadMOMPDF.pending, (state) => {
        state.isLoaded = false;
      })
      .addCase(downloadMOMPDF.fulfilled, (state) => {
        state.isLoaded = true;
      })
      .addCase(downloadMOMPDF.rejected, (state) => {
        state.isLoaded = true;
      })

      // Upload MOM PDF
      .addCase(uploadMOMPDF.pending, (state) => {
        state.isLoaded = false;
      })
      .addCase(uploadMOMPDF.fulfilled, (state) => {
        state.isLoaded = true;
      })
      .addCase(uploadMOMPDF.rejected, (state) => {
        state.isLoaded = true;
      });
  },
});

export default momSlice.reducer;
